import { useNavigate } from "react-router-dom";

const customNavigate = (url: string) => {
  if (window.location) {
    window.location.href = url;
  }
};

export const useCustomNavigate = () => {
  try {
    const defaultNavigate = useNavigate();
    return (url: string, forceReload: boolean = false) => {
      if (forceReload) {
        return customNavigate(url);
      }

      return defaultNavigate(url);
    };
  } catch (e) {
    return customNavigate;
  }
};
